var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportantRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3C9.4243 3 8.93112 3.3525 8.72221 3.85462L1.20823 16.8764V16.8777C1.07262 17.0972 1.00052 17.3503 1 17.6087C1 17.9777 1.14588 18.3316 1.40554 18.5925C1.66521 18.8534 2.01739 19 2.38462 19C2.4171 18.9998 2.44958 18.9984 2.48197 18.9959L2.48468 19H10H17.5153L17.518 18.9946C17.5504 18.9975 17.5829 18.9993 17.6154 19C17.9826 19 18.3348 18.8534 18.5945 18.5925C18.8541 18.3316 19 17.9777 19 17.6087C18.9997 17.3499 18.9276 17.0963 18.7918 16.8764L18.781 16.8573L18.7796 16.856L11.2778 3.85462C11.0689 3.3525 10.5757 3 10 3Z",
    fill: "#B3261E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8397 8.81543H9.16031L9.29958 13.3181H10.7004L10.8397 8.81543Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9127 15.5274C10.9127 15.0022 10.5718 14.6945 10.0027 14.6945C9.42878 14.6945 9.08594 15.0022 9.08594 15.5274C9.08594 16.0429 9.42947 16.3494 10.0027 16.3494C10.5718 16.3494 10.9127 16.0429 10.9127 15.5274Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantRed);
export default __webpack_public_path__ + "static/media/important-red.4751baff20166f8bc9d3ec14be2f96b3.svg";
export { ForwardRef as ReactComponent };